import React from "react";

import HeroSectionEditor from "../sections/HeroSectionEditor";
import CTASectionEditor from "../sections/CTASectionEditor";
import GenericSectionEditor from "../sections/GenericSectionEditor";
import GallerySectionEditor from "../sections/GallerySectionEditor";
import FeaturesSectionEditor from "../sections/FeaturesSectionEditor";
import TestimonialsSectionEditor from "../sections/TestimonialsSectionEditor";
import CategorySectionEditor from "../sections/CategorySectionEditor";
import LocationSectionEditor from "../sections/LocationSectionEditor";
import ServiceSectionEditor from "../sections/ServiceSectionEditor";

export default function ContentTab({
  resolvedType,
  editedSection,
  cfg,
  mergedCfg,
  hasKey,
  onConfigChange,
  uploadImage,
  t,
}) {
  const typeLower = (resolvedType || "").toLowerCase();

  const isHero = resolvedType === "hero";
  const isGallery = resolvedType === "gallery";
  const isCategorySection = typeLower === "categorysection";
  const isFeatures = editedSection?.type === "features";
  const isTestimonials = editedSection?.type === "testimonials";
  const isCta = editedSection?.type === "cta";
  const isLocationSection = typeLower === "locationsection";
  const isServiceSection = typeLower === "servicesection";

  if (isHero) {
    return (
      <HeroSectionEditor
        config={cfg}
        template={editedSection?.template}
        onChange={onConfigChange}
        uploadImage={uploadImage}
        t={t}
      />
    );
  }

  if (isGallery) {
    return (
      <GallerySectionEditor
        config={mergedCfg}
        template={editedSection?.template}
        onChange={onConfigChange}
        uploadImage={uploadImage}
        t={t}
      />
    );
  }

  if (isCta) {
    return (
      <CTASectionEditor
        config={cfg}
        template={editedSection?.template}
        onChange={onConfigChange}
        t={t}
      />
    );
  }

  if (isLocationSection) {
    return (
      <LocationSectionEditor
        config={cfg}
        template={editedSection?.template}
        onChange={onConfigChange}
        uploadImage={uploadImage}
        t={t}
      />
    );
  }

  if (isServiceSection) {
    return (
      <ServiceSectionEditor
        config={mergedCfg}
        template={editedSection?.template}
        onChange={onConfigChange}
        uploadImage={uploadImage}
        t={t}
      />
    );
  }

  if (isFeatures) {
    return (
      <FeaturesSectionEditor
        config={cfg}
        template={editedSection?.template}
        onChange={onConfigChange}
        t={t}
      />
    );
  }

  if (isCategorySection) {
    return (
      <CategorySectionEditor
        config={cfg}
        template={editedSection?.template}
        onChange={onConfigChange}
        uploadImage={uploadImage}
        t={t}
      />
    );
  }

  if (isTestimonials) {
    return (
      <TestimonialsSectionEditor
        config={cfg}
        template={editedSection?.template}
        onChange={onConfigChange}
        t={t}
      />
    );
  }

  return <GenericSectionEditor config={cfg} hasKey={hasKey} onChange={onConfigChange} />;
}